module.exports = __webpack_public_path__ + "media/images/file-icons/64/006-record-d9c43fce26f82a9ddbeaafc2f11c8af0.png";